import { render, staticRenderFns } from "./stashboard-preview.vue?vue&type=template&id=6ecadc64&scoped=true&"
import script from "./stashboard-preview.vue?vue&type=script&lang=js&"
export * from "./stashboard-preview.vue?vue&type=script&lang=js&"
import style0 from "./stashboard-preview.vue?vue&type=style&index=0&id=6ecadc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecadc64",
  null
  
)

export default component.exports